import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import CreateBallot from "./CreateBallot";
import GetBallots from "./GetBallots";
import useCashPayment from "./useCashPayment";
import translate from "../../../../i18n/translate";
import CashPaymentFirstScreen from "./CashPaymentFirstScreen";
import View from "../../../utils/View";

const screens = ["introductionScreen", "tableScreen", "formScreen"];

const CashPayment = () => {
  const intl = useIntl();
  const [currentScreen, setCurrentScreen] = useState(screens[1]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    transactions,
    paginationConfig,
    createBallot,
    loading,
    createBallotError,
  } = useCashPayment();

  const onReturn = () => {
    setCurrentScreen(paginationConfig?.total ? screens[1] : screens[0]);
  };

  const toastSuccess = (text) => {
    toast.success(text);
  };

  const toastError = (text) => {
    toast.error(text);
  };

  const generateBallot = async (body) => {
    try {
      setIsSubmitting(true);
      const newBallot = await createBallot(body);

      if (newBallot) {
        toastSuccess(translate("cashPayment.snackMessages.ballotCreated"));
        onReturn();
      }
    } catch (e) {
      toastError(translate("cashPayment.snackMessages.ballotNotCreated"));
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!loading) {
      setCurrentScreen(paginationConfig?.total ? screens[1] : screens[0]);
    }
  }, [paginationConfig?.total, loading]);

  const screensObj = {
    [screens[0]]: (
      <CashPaymentFirstScreen onClick={() => setCurrentScreen(screens[2])} />
    ),
    [screens[1]]: (
      <GetBallots
        onCreate={() => setCurrentScreen(screens[2])}
        transactions={transactions}
        loading={loading}
        paginationConfig={paginationConfig}
        toastSuccess={toastSuccess}
      />
    ),
    [screens[2]]: (
      <CreateBallot
        intl={intl}
        onReturn={onReturn}
        onSubmit={generateBallot}
        isSubmitting={isSubmitting}
        error={createBallotError}
        toastError={toastError}
      />
    ),
  };

  return (
    <>
      <View translateTitleKey="menu.cashPayment">
        {screensObj[currentScreen]}
      </View>
    </>
  );
};

export default CashPayment;
